import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"

export default createReactClass({
  displayName: "TabContent",
  propTypes: {
    className: PropTypes.string,
    isActive: PropTypes.bool,
  },
  render() {
    return this.props.isActive ? <div>{this.props.children}</div> : null
  },
})
